import AppsSection from './components/AppsSection'

export function renderSecondaryNavAppsSection(section, ctx) {
  const key = `${section.type}-${ctx.index}`

  if (section.type === 'appsPreview') {
    return <AppsSection key={key} apps={ctx.topApps ?? []} onAppClick={ctx.onAppClick} />
  }

  if (section.type === 'appsLanding') {
    return (
      <AppsSection
        key={key}
        apps={ctx.allApps ?? []}
        showAll
        onAppClick={(app) => {
          ctx.onAppClick?.(app)
        }}
      />
    )
  }

  return null
}
